module.exports = __webpack_public_path__ + "static/lightning-color-picker-8aecc599739327975db583017a9d25f7.png";